module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo01-nikon-5de8ecf84a8afcb9ae836fca75ecc908.jpg";